"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.defaultBreadcrumbState = void 0;
exports.defaultBreadcrumbState = {
    breadcrumbList: [
        {
            name: 'Home',
            link: '/',
        },
        {
            name: 'Property Search For Rent',
            action: '',
            link: '/en/property-search/rent/keyword-ocean',
        },
        {
            name: 'The Mediterranean',
            action: 'newProperty',
            link: '/new-developments/the-mediterranean',
        },
    ],
    tFormat: {
        newProperty: 'The Mediterranean',
        developments: 'New Developments',
        searchPage: 'Property for {0} in Hong Kong',
        homePage: 'Home',
        buy: 'Buy',
        rent: 'Rent',
    },
};
